import React, { createContext, useMemo, useState } from 'react'
import { IntlProvider } from 'react-intl'

import locales, {
	Locale,
	defaultLocale as initialLocale,
	isValidLocale,
} from '../i18n'

export type LanguageContextProps = {
	locale: Locale
	setLocale: (locale: Locale) => void
}

const defaultContextValues: LanguageContextProps = {
	locale: initialLocale,
	setLocale: () => {},
}

export const LanguageContext = createContext<LanguageContextProps>(
	defaultContextValues
)

export type LanguageProviderProps = {
	children: React.ReactNode
}

const USER_LOCALE = navigator.language.split('-')[0]

const LanguageProvider = ({ children }: LanguageProviderProps) => {
	const [locale, setLocale] = useState(
		isValidLocale(USER_LOCALE) ? USER_LOCALE : initialLocale
	)

	const localeMessages = locales[locale] ?? locales[initialLocale]

	const contextValue = useMemo(
		() => ({
			locale,
			setLocale,
		}),
		[locale, setLocale]
	)

	return (
		<LanguageContext.Provider value={contextValue}>
			{/** @ts-ignore * */}
			<IntlProvider
				messages={localeMessages}
				locale={locale}
				defaultLocale={initialLocale}
			>
				{/** @ts-ignore * */}
				{children}
			</IntlProvider>
		</LanguageContext.Provider>
	)
}

export default LanguageProvider
